import { SvgIconProps } from './icon-props';

export default function PlusThin({ height = 24, width = 24, className }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			className={className}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12.6 11.4V0H11.4V11.4H0V12.6H11.4V24H12.6V12.6H24V11.4H12.6Z" />
		</svg>
	);
}
